import { useQuery } from 'react-query';
import { getUserData } from './authApis';

export const userDataQuery = () => useQuery(['getUserData'],
  async () => (await getUserData()).data.data,
  {
    staleTime: Infinity,
    cacheTime: Infinity,
  });
